import { useState } from 'react';

import { gql, useQuery } from '@apollo/client';

export const GET_SALARY_TYPES = gql`
  query getSalaryTypes($companyId: String!, $queryOptions: QueryOptionsInput) {
    getSalaryTypes(companyId: $companyId, queryOptions: $queryOptions) {
      collection {
        _id
        name
        salaryTypeNumber
        companyId
        createdAt
        createdBy
        clients {
          datevNumber
          _id
        }
      }
      totalCount
    }
  }
`;

export const useGetSalaryTypes = (companyId?: string) => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>([
    { field: 'name', sortBy: 1 },
  ]);
  const pageSize = 12;
  const { data, loading } = useQuery(GET_SALARY_TYPES, {
    variables: {
      companyId,
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
    },
    skip: !companyId,
    fetchPolicy: 'no-cache',
  });

  const salaryTypes = data?.getSalaryTypes || {};

  return {
    collection: salaryTypes?.collection || [],
    loading,
    paginationConfig: {
      total: salaryTypes?.totalCount || 0,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
    onTableChange: (a: any, b: any, { order }: any) => {
      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        setNameSort([{ field: 'name', sortBy }]);
      }
    },
  };
};
